export const state = {
    email: "", 
    otp: "",
}

export const mutations = {
    SET_EMAIL (state, payload) {
        state.email = payload;
    },
    SET_OTP (state, payload) {
        state.otp = payload;
    }
}